import { getFunctions, httpsCallable } from "firebase/functions";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { app, db } from "../firebase/config";

const functions = getFunctions(app);

function paraMillis(valor) {
  if (!valor) return 0;

  if (typeof valor?.toDate === "function") {
    const ms = valor.toDate().getTime();
    return Number.isNaN(ms) ? 0 : ms;
  }

  if (valor instanceof Date) {
    const ms = valor.getTime();
    return Number.isNaN(ms) ? 0 : ms;
  }

  if (typeof valor === "object") {
    if (typeof valor.seconds === "number") {
      return valor.seconds * 1000;
    }

    if (typeof valor._seconds === "number") {
      return valor._seconds * 1000;
    }
  }

  const ms = new Date(valor).getTime();
  return Number.isNaN(ms) ? 0 : ms;
}

function normalizarBilling(data) {
  if (!data) {
    return {
      appLiberado: false,
      statusAcesso: "blocked",
      trialAtivo: false,
      diasRestantesTrial: 0,
      assinaturaValida: false,
      diasRestantesAssinatura: 0,
      assinaturaAtiva: false,
      paymentApproved: false,
      paymentLink: null,
      sandboxPaymentLink: null,
      accessExpiresAt: null,
      trialStartedAt: null,
      trialEndsAt: null,
    };
  }

  const agora = Date.now();
  const trialStartedAtMs = paraMillis(data.trialStartedAt);
  const trialEndsAtMs = paraMillis(data.trialEndsAt);
  const accessExpiresAtMs = paraMillis(data.accessExpiresAt);

  let trialAtivo = false;
  let diasRestantesTrial = 0;

  if (trialEndsAtMs > agora) {
    trialAtivo = true;
    diasRestantesTrial = Math.ceil(
      (trialEndsAtMs - agora) / (1000 * 60 * 60 * 24)
    );
  } else if (trialStartedAtMs > 0) {
    const fimCalculado = trialStartedAtMs + 15 * 24 * 60 * 60 * 1000;

    if (fimCalculado > agora) {
      trialAtivo = true;
      diasRestantesTrial = Math.ceil(
        (fimCalculado - agora) / (1000 * 60 * 60 * 24)
      );
    }
  }

  const assinaturaValida = accessExpiresAtMs > agora;
  const diasRestantesAssinatura = assinaturaValida
    ? Math.ceil((accessExpiresAtMs - agora) / (1000 * 60 * 60 * 24))
    : 0;

  let statusAcesso = "blocked";

  if (assinaturaValida) statusAcesso = "active";
  else if (trialAtivo) statusAcesso = "trialing";

  return {
    ...data,
    trialAtivo,
    diasRestantesTrial,
    assinaturaValida,
    diasRestantesAssinatura,
    assinaturaAtiva: Boolean(data.assinaturaAtiva),
    paymentApproved: Boolean(data.paymentApproved),
    appLiberado: trialAtivo || assinaturaValida,
    statusAcesso,
  };
}

export async function inicializarBilling() {
  const fn = httpsCallable(functions, "inicializarBilling");
  const result = await fn();
  return normalizarBilling(result.data);
}

export async function verificarAcessoApp() {
  const fn = httpsCallable(functions, "verificarAcessoApp");
  const result = await fn();
  return normalizarBilling(result.data);
}

export async function buscarBilling(uid) {
  const ref = doc(db, "usuarios", uid, "private", "billing");
  const snap = await getDoc(ref);

  return snap.exists()
    ? normalizarBilling({ id: snap.id, ...snap.data() })
    : normalizarBilling(null);
}

export function ouvirBilling(uid, onData, onError) {
  const ref = doc(db, "usuarios", uid, "private", "billing");

  return onSnapshot(
    ref,
    (snap) => {
      onData(
        snap.exists()
          ? normalizarBilling({ id: snap.id, ...snap.data() })
          : normalizarBilling(null)
      );
    },
    onError
  );
}